import { Injectable } from '@angular/core'
import { CoreSettingsService } from '../settings/core-settings.service'
import { CoreEnvironmentService } from './core-environment.service'

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService extends CoreEnvironmentService {
  constructor(coreSettings: CoreSettingsService) {
    super(coreSettings)
  }

  saveColorsUrl(entityId?: number): string {
    return entityId
      ? `${this.coreSettings.settings.urls.saveColorsUrl}/${entityId}`
      : this.coreSettings.settings.urls.saveColorsUrl
  }

  resetColors(): string {
    return this.coreSettings.settings.urls.resetColors
  }

  prodsPageAPIUrl(): string {
    return this.coreSettings.settings.urls.prodspageServiceAPI
  }

  getPaymentDomainUrl(): string {
    return this.coreSettings.settings.urls.paymentDomainUrl
  }

  getSettingsUrl(): string {
    return this.coreSettings.settings.urls.settingsUrl
  }

  getCommonDomainUrl(): string {
    return this.coreSettings.settings.urls.commonDomainUrl
  }
}

@Injectable({
  providedIn: 'root'
})
export class RoutingPathService {
  constructor(private coreSettings: CoreSettingsService) {}

  getBeatmakerPageUrl(beatmakerId: number | undefined): string {
    if (!beatmakerId) {
      return ''
    }
    return this.coreSettings.settings.routingUrl.beatmakerPage?.replace('{{beatmakerId}}', beatmakerId.toString())
  }

  getBeatPageUrl(beatId: number): string {
    return this.coreSettings.settings.routingUrl.beatPage?.replace('{{beatId}}', beatId.toString())
  }

  getFreeBeatPageUrl(beatId: number): string {
    return this.coreSettings.settings.routingUrl.freeBeatPage?.replace('{{beatId}}', beatId.toString())
  }

  getArtistPageUrl(artistId: number | undefined): string {
    if (!artistId) {
      return ''
    }
    return this.coreSettings.settings.routingUrl.artistPage?.replace('{{artistId}}', artistId.toString())
  }

  getSongPageUrl(songId: string): string {
    return this.coreSettings.settings.routingUrl.songPage?.replace('{{songId}}', songId.toString())
  }

  getCheckoutUrl(): string {
    return this.coreSettings.settings.routingUrl.checkoutPage
  }
}
